// @angular
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

// services
import { AuthenticationService } from '../../services/authentication.service';
import { IAuthentication } from '../../services/authentication.interface';

@Component({
  template: `<!-- no template -->`,
  selector: 'app-authentication-login',
})
export class AuthenticationLoginComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private auth: AuthenticationService,
  ) {}

  ngOnInit() {
    const user: IAuthentication = this.auth.user$.getValue();

    this.route.queryParams.subscribe((params: Params) => {
      if (!user.loggedIn) {
        let path = params['path'];
        // I think this has path when it's coming from the auth guard and doesn't when it's coming from routing rules
        if (!path) {
          path = '/' + this.auth.getValidQueryParametersForLoginPath(path);
        }

        this.auth.requestLogin(path);
      } else {
        // we need to trigger a validation check if the user is already cached and logged in
        // from saved local storage

        this.router.navigate(['/login-success']);
      }
    });
  }
}
